import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../../_auth/AuthContext';
import { Grid, Typography } from '@material-ui/core';
import { IBrazeSummary, IMemberSummary } from '../../_types/member';
import { makeStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';


interface Props {
    
    member: IMemberSummary;
};
interface kvp { key: string, value:any };


const Member_EW_Summary: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        table: {
            maxHeight: 440
        },
        paper: {
            width: 768
        },
        section_header: {
            paddingLeft: 10
            
        }
    //     home: { color: "primary" },
    //     away: { color: theme.palette.grey[900] }
    }));
    const classes=useStyles();


    return (

        <Paper >
        <Typography className={classes.section_header} variant="h6">EverWash</Typography>
        <TableContainer className={classes.table} >
            <Table size="small">
                
                <TableBody>
                    <TableRow>
                        <TableCell>Name:</TableCell>
                        <TableCell>{prop.member.name}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Unique ID:</TableCell>
                        <TableCell>{prop.member.uuid}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Stripe ID:</TableCell>
                        <TableCell>{prop.member.pp_id}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Email:</TableCell>
                        <TableCell>{prop.member.email}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Phone:</TableCell>
                        <TableCell>{prop.member.phone}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>

    )
}

const Member_Braze_Summary: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);
    const [data,setData] = useState<IBrazeSummary | null>(null);

    React.useEffect(() => {
        setData(_braze());
    },[]);


    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        table: {
            maxHeight: 440
        },
        paper: {
            width: 768
        },
        section_header: {
            paddingLeft: 10
            
        }
    //     home: { color: "primary" },
    //     away: { color: theme.palette.grey[900] }
    }));

    const classes=useStyles();
    const _braze = () => {
        let toReturn: IBrazeSummary | null = null;

        if (prop.member.braze && prop.member.braze.length > 0) {
            let match = prop.member.braze.find(g => g.custom_attributes?.primary === true );
            if (match) {
                toReturn = match;
            }
        }

        return toReturn;
    }

    const _brazeToKVP = ():kvp[] => {

        let toReturn: kvp[] = [];

        if (data && data.custom_attributes) {
            let attr: {[index: string]:any} = {};
            attr = data.custom_attributes;

            Object.keys(attr).forEach(key => {
                if (attr[key] && attr[key].toString().replace(" ","").length > 0) {
                    toReturn.push({key: key, value: attr[key].toString()});
                }
                
            });            

        }

        return toReturn;
    }

    if (data) {
    return (
        <Grid item>
        <Paper >
        <Typography className={classes.section_header} variant="h6">Braze</Typography>
        <TableContainer className={classes.table} >
            <Table size="small">
                
                <TableBody>
                    {_brazeToKVP().map((e, i) => (
                        <TableRow key={i}>
                            <TableCell>{e.key}</TableCell>
                            <TableCell>{e.value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>
    </Grid>
    )
    } else { 
        return (<Grid item>No Braze data found</Grid>)
    }
    
}

const Member_PP_Summary: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        table: {
            maxHeight: 440
        },
        paper: {
            width: 768
        },
        section_header: {
            paddingLeft: 10
            
        }
    //     home: { color: "primary" },
    //     away: { color: theme.palette.grey[900] }
    }));

    const classes=useStyles();


 
    const _ToKVP = ():kvp[] => {

        let toReturn: kvp[] = [];

        if (prop.member.payment_provider) {
            let attr: {[index: string]:any} = {};
            attr = prop.member.payment_provider;

            Object.keys(attr).forEach(key => {
                
                if (key !== "subscriptions") {
                    if (attr[key] && attr[key].toString().replace(" ","").length > 0) {
                        toReturn.push({key: key, value: attr[key].toString()});
                    }
                }
                
            });            

        }

        return toReturn;
    }

    if (prop.member.payment_provider) {
    return (
        <Grid item>
        <Paper >
        <Typography className={classes.section_header} variant="h6">Stripe</Typography>
        <TableContainer className={classes.table} >
            <Table size="small">
                
                <TableBody>
                    {_ToKVP().map((e,i) => (
                        <TableRow key={i}>
                            <TableCell>{e.key}</TableCell>
                            <TableCell>{e.value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>
    </Grid>
    )
    } else { 
        return (<Grid item>No Payment Provider data found</Grid>)
    }
    
}

const MemberSummary: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);


    return (

        <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={2}>
            <Grid  item>
                <Member_EW_Summary member={prop.member}></Member_EW_Summary>
            </Grid>
            <Member_Braze_Summary member={prop.member}></Member_Braze_Summary>
            <Member_PP_Summary member={prop.member}></Member_PP_Summary>
            
        </Grid>

    )
}

export default MemberSummary;